import React, { useContext } from 'react';
import { MultiSelect } from 'primereact/multiselect';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import { UserDetailsContext } from 'context/userDetailsContext';
import { LoaderComponent } from 'shared/LoaderComponent';

function PracticeAreaFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  const practiceAreaList = userContext?.practiceAreaList || [];
  const isPracticeAreaLoading = userContext?.isPracticeAreaLoading || false;

  return (
    <MultiSelect
      name="practiceArea"
      value={practiceAreaList?.length > 0 ? fileManagerFilters?.practiceArea : []}
      options={practiceAreaList}
      onChange={(e) => {
        onFilterChange(e);
        setSelectedRows([]);
      }}
      placeholder="All Practice Areas"
      optionLabel="practice_area_name"
      optionValue="practice_area_id"
      display="chip"
      filter
      className="file-manager-select w-100"
      panelFooterTemplate={isPracticeAreaLoading ? LoaderComponent : null}
      disabled
    />
  );
}

export default PracticeAreaFilter;
